var $f1503e0b0dc7fd10$exports = {};
$f1503e0b0dc7fd10$exports = {
    "valid": `Galioja`
};


export {$f1503e0b0dc7fd10$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
